module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("popup_confirm_change_country", [["div",{"class":"dlg-content","data-fox-alias":"1","data-fox-context":"popup_confirm_change_country"},[["textNode",{"text":" Are you sure you want to change your country of residence? "}],["span",{},[],[["payoutMethod","__text",true]]],["textNode",{"text":" payout method is not supported for "}],["span",{},[],[["countries","__text",true]]],["textNode",{"text":" at the moment. "}]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/templates/account/changeCountryConfirm.tpl
// module id = 223
// module chunks = 2